const IsoDateSuffixes = ['D', 'M', 'Y'];
const IsoTimeSuffixes = ['S', 'M', 'H'];

const getIsoTime = (dataStringList: string[], IsoSuffixes: string[]) =>
  dataStringList.reduce((acc, time, i) => {
    const paresedTime = parseInt(time, 10);
    const timeWithSuffix = paresedTime ? `${paresedTime}${IsoSuffixes[i]}` : '';

    return `${timeWithSuffix}${acc}`;
  }, '');

// format of dataString: yy:mm:dd:hh:mm:ss -> 5:03:00:01:05:11
export default (dataString: string) => {
  const fullDataStringList = dataString.split(':').reverse();
  const timeStringList = fullDataStringList.slice(0, 3);
  const dataStringList = fullDataStringList.slice(3);

  const timeIso = getIsoTime(timeStringList, IsoTimeSuffixes);
  const dateIso = getIsoTime(dataStringList, IsoDateSuffixes);

  const timeDivider = timeIso ? 'T' : '';

  return `P${dateIso}${timeDivider}${timeIso}`;
};
